/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

export const ADD_ENTITY_TYPE = 'ADD_ENTITY_TYPE';
export const FORMS = {
  ADD_ENTITY_TYPE: 'ADD_ENTITY_TYPE',
  DELETE_ENTITY_TYPE: 'DELETE_ENTITY_TYPE',
};

export const ENTITY = 'entity';
export const ALERT_TYPE = 'alerts';
export const SUMMARY_TYPE = 'summary';
export const DATA_TYPE = 'data';
export const RULE_TYPE = 'rules';

export const ENTITYTYPE_ORIGIN = {
  ASUI: 'ASUI', // those created from the UI
};

export const AS_LOG_STATES = {
  ERROR: 'ERROR',
  SUCCESS: 'SUCCESS',
};

export const AS_LOG_OPERATIONS = {
  PIPELINE: 'PIPELINE',
  REGISTER: 'REGISTER',
};
